import logo from '../img/logo.png';
import { Link } from "react-router-dom";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    Logo: {
        paddingTop: '0.67em',
        paddingBottom:'0.67em'
    },
    Link: {
        display: 'inline-flex',
        color: "black",
        marginLeft: "24px",
        textDecoration: "none"
    }
  });

const Logo = () => {
    const classes = useStyles();
    return (
        <Link className={classes.Link} to="/" underline="none" state={{anchor:"default"}}>
            <div className={classes.Logo}>
              <img src={logo} alt="logo" width="48" height="60"/>
            </div>
        </Link>
    );

}

export default Logo;